export default "__VITE_ASSET__C8gH3DCo__"